import React, { useContext, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { FormControlLabel, FormHelperText, InputLabel } from '@material-ui/core';
import AppContext from '../../../App/AppContext';
import { getAllVmrsCategorys, getVmrsSubCategoryById, postVmrsSubCategoryData } from '../../../Core/Service/vmrs-service';
import { SecondaryButton, SecondaryCheckbox, SelectBox, SingelSelect, TextBox } from '../../../Core/FormInput';

const DialogStyle = {
    dialogInput: { width: '100%' },
    mandatoryLabel: { color: 'red' }
};

const AddEditVmrsModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [btnLoader, setBtnLoader] = useState(false);
    const [state, setState] = useState({
        vmrsSubCategoryID: null,
        vmrsCategoryValue: '',
        vmrsSubCategoryDescription: '',
        // vmrsTaskCodeID: '',
        vmrsSubCategoryNominalCode: '',
        vmrsCategoryList: [],
        errors: {},
        vmrsSubCategoryInternalRate: '',
        vmrsSubCategoryRechargeRate: '',
        vmrsSubCategoryFixedCost: false
    });

    const [tempOptions, setTempOptions] = useState({
        vmrsCategoryValueID: null
    });
    useEffect(async () => {
        let resCategoryDropDown = await getAllVmrsCategorys();
        setState((st) => ({
            ...st,
            vmrsCategoryList: resCategoryDropDown.data.list.map((w) => ({
                id: w.vmrsCategoryID,
                name: w.vmrsDescription
            }))
        }));
        if (props.subCategoryId) {
            let res = await getVmrsSubCategoryById(props.subCategoryId);
            setState((st) => ({
                ...st,
                vmrsSubCategoryDescription: res.data.vmrsSubCategoryDescription,
                vmrsSubCategoryID: res.data.vmrsSubCategoryID,
                // vmrsTaskCodeID: res.data.vmrsTaskCodeID,
                vmrsSubCategoryNominalCode: res.data.vmrsSubCategoryNominalCode,
                vmrsCategoryValue: res.data.vmrsCategory,
                vmrsDescription: res.data.vmrsDescription,
                vmrsSubCategoryInternalRate: res.data.vmrsSubCategoryInternalRate,
                vmrsSubCategoryRechargeRate: res.data.vmrsSubCategoryRechargeRate,
                vmrsSubCategoryFixedCost: res.data.vmrsSubCategoryFixedCost
            }));
        }
    }, []);

    useEffect(() => {
        let vmrsCategoryValueID = null;
        if (state.vmrsCategoryValue) {
            vmrsCategoryValueID = state.vmrsCategoryList.find(({ id }) => id === state.vmrsCategoryValue);
        }
        setTempOptions((st) => ({
            ...st,
            vmrsCategoryValueID: vmrsCategoryValueID
        }));
    }, [state.vmrsCategoryValue]);

    const inputChange = (ev) => {
        let temp = ev.target;
        setState((st) => ({
            ...st,
            [temp.name]: temp.type === 'checkbox' ? temp.checked : temp.value
        }));
    };

    const singleSelectChange = (nm) => (ev, val) => {
        setTempOptions((st) => ({ ...st, [nm]: val }));
    };

    const validations = () => {
        const { vmrsSubCategoryDescription, vmrsSubCategoryNominalCode } = state;
        let formIsValid = true;
        let errors = {};

        if (!/[^\s]/.test(vmrsSubCategoryDescription)) {
            errors.vmrsSubCategoryDescription = 'This field is required';
            formIsValid = false;
        }
        // if (!/[^\s]/.test(vmrsTaskCodeID)) {
        //     errors.vmrsTaskCodeID = 'This field is required';
        //     formIsValid = false;
        if (!/[^\s]/.test(vmrsSubCategoryNominalCode)) {
            errors.vmrsSubCategoryNominalCode = 'This field is required';
            formIsValid = false;
        }
        if (tempOptions.vmrsCategoryValueID?.id == null || tempOptions.vmrsCategoryValueID.id === '') {
            errors.vmrsCategory = 'This field is required';
            formIsValid = false;
        }
        setState((st) => ({ ...st, errors: errors }));
        return formIsValid;
    };

    const submitHandler = async () => {
        if (validations()) {
            const formData = {
                vmrsSubCategoryDescription: state.vmrsSubCategoryDescription,
                vmrsSubCategoryID: state.vmrsSubCategoryID,
                // vmrsTaskCodeID: state.vmrsTaskCodeID,
                vmrsSubCategoryNominalCode: state.vmrsSubCategoryNominalCode,
                vmrsCategory: tempOptions.vmrsCategoryValueID?.id,
                vmrsSubCategoryInternalRate: state.vmrsSubCategoryInternalRate,
                vmrsSubCategoryRechargeRate: state.vmrsSubCategoryRechargeRate,
                vmrsSubCategoryFixedCost: state.vmrsSubCategoryFixedCost
            };
            setBtnLoader(true);
            let res = await postVmrsSubCategoryData(formData);
            if (res.success) {
                showToast(res.message);
                props.onClose(true);
            } else {
                showToast(res.message);
            }
            setBtnLoader(false);
        }
    };

    return (
        <Grid container direction={'row'} spacing={2} alignItems="center" justify="center">
            <Grid item xs={12} className="mandatory-fields">
                <InputLabel required shrink>
                    VMRS Category
                </InputLabel>
                <SingelSelect value={tempOptions.vmrsCategoryValueID} onChange={singleSelectChange('vmrsCategoryValueID')} options={state.vmrsCategoryList} />
                <FormHelperText error>{state.errors.vmrsCategory}</FormHelperText>
            </Grid>
            <Grid item xs={12} className="mandatory-fields">
                <InputLabel shrink required>
                    Description
                </InputLabel>
                <TextBox name="vmrsSubCategoryDescription" value={state.vmrsSubCategoryDescription} onChange={inputChange} />
                <FormHelperText error>{state.errors.vmrsSubCategoryDescription}</FormHelperText>
            </Grid>
            <Grid item xs={12} className="mandatory-fields">
                <InputLabel shrink required>
                    Nominal Code
                </InputLabel>
                <TextBox name="vmrsSubCategoryNominalCode" value={state.vmrsSubCategoryNominalCode} onChange={inputChange} />
                <FormHelperText error>{state.errors.vmrsSubCategoryNominalCode}</FormHelperText>
            </Grid>
            <Grid item xs={4}>
                <InputLabel shrink>Internal Rate</InputLabel>
                <TextBox name="vmrsSubCategoryInternalRate" value={state.vmrsSubCategoryInternalRate} onChange={inputChange} />
                <FormHelperText error>{state.errors.vmrsSubCategoryInternalRate}</FormHelperText>
            </Grid>
            <Grid item xs={4}>
                <InputLabel shrink>Recharge Rate</InputLabel>
                <TextBox name="vmrsSubCategoryRechargeRate" value={state.vmrsSubCategoryRechargeRate} onChange={inputChange} />
                <FormHelperText error>{state.errors.vmrsSubCategoryRechargeRate}</FormHelperText>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right' }}>
                {/* <SecondaryCheckbox name="vmrsSubCategoryFixedCost" checked={state.vmrsSubCategoryFixedCost} onChange={inputChange} label="Fixed Cost?" /> */}
                <FormControlLabel
                    control={<SecondaryCheckbox checked={state.vmrsSubCategoryFixedCost} name="vmrsSubCategoryFixedCost" onChange={inputChange} />}
                    label="Fixed Cost?"
                />
            </Grid>
            <Grid item xs={12} className="submit_btn">
                <SecondaryButton isBtnLoader={btnLoader} onClick={submitHandler} fullWidth>
                    Submit
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default AddEditVmrsModal;
